// 优惠券类型
export const couponType = val => {
  switch (val) {
    case 0:
      return '满减券';
      break;
    case 1:
      return '折扣券';
      break;
    case 2:
      return '无门槛';
      break;
    default:
      break;
  }
};
// 满减邮状态
export const fllReductionStatus = val => {
  switch (val) {
    case 1:
      return '未开始';
      break;
    case 2:
      return '进行中';
      break;
    case 3:
      return '已结束';
      break;
    default:
      break;
  }
};
export const getChannelType = val => {
  switch (val) {
    case 0:
      return '未知';
      break;
    case 1:
      return '微信';
      break;
    case 2:
      return '支付宝';
      break;
    case 3:
      return 'h5';
      break;
    case 4:
      return '支付宝澳门';
      break;
    default:
      break;
  }
};
export const getPayType = val => {
  switch (val) {
    case 1:
      return '微信';
    case 2:
      return '支付宝';
    case 3:
      return '银联';
    case 4:
      return '支付宝澳门';
    default:
      return '未知';
  }
};
export const channelTypeShop = val => {
  switch (val) {
    case 0:
      return '未知';
      break;
    case 1:
      return '微信小程序';
      break;
    case 2:
      return '支付宝小程序';
      break;
    case 3:
      return 'h5';
      break;
    case 4:
      return '支付宝澳门';
      break;
    default:
      break;
  }
};
// 拼团组件状态
export const StatusOfDoughAssembly = val => {
  switch (val) {
    case 2:
      return '已结束';
    case 0:
      return '未开始';
      break;
    case 1:
      return '进行中';
      break;
    default:
      break;
  }
};
export const GroupChannel = val => {
  switch (val) {
    case 0:
      return '未知';
      break;
    case 1:
      return '微信';
      break;
    case 2:
      return '支付宝';
      break;
    case 3:
      return 'h5';
      break;
    case 4:
      return '支付宝澳门';
      break;
    default:
      break;
  }
};
export default {
  couponType,
  fllReductionStatus,
  getChannelType,
  getPayType,
  channelTypeShop,
  StatusOfDoughAssembly,
  GroupChannel,
};
